import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const isFor = ['Jóvenes de 17 a 24 años que acaban de recibir sus primeros sueldos.', 'Hijos de inmigrantes latinos que quieren ser los primeros en su familia en construir patrimonio real.', 'Estudiantes que quieren evitar graduarse con una montaña de deudas innecesarias.', 'Padres que quieren regalarle a sus hijos la educación financiera que ellos nunca recibieron.'];
const isNotFor = ['Personas que buscan esquemas de "hazte rico rápido" o criptomonedas mágicas.', 'Quienes no están dispuestos a seguir un plan disciplinado por al menos 21 días.', 'Quienes prefieren aparentar éxito con marcas de lujo antes de tener dinero en el banco.'];
export function WhoIsFor() {
  return <section className="py-24 px-6" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12" data-id="element-178">
          {/* Who it is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/[0.02] border border-green-500/20 rounded-3xl p-8 md:p-10" data-id="element-179">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white flex items-center gap-3" data-id="element-180">
              <CheckCircle2Icon className="w-8 h-8 text-green-500" data-id="element-181" />
              Para Quién Es
            </h3>
            <ul className="space-y-6" data-id="element-182">
              {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-183">
                  <div className="w-2 h-2 rounded-full bg-green-500 mt-2.5 shrink-0" data-id="element-184" />
                  <p className="text-lg text-gray-300" data-id="element-185">{text}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* Who it is NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/[0.02] border border-red-500/20 rounded-3xl p-8 md:p-10" data-id="element-186">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white flex items-center gap-3" data-id="element-187">
              <XCircleIcon className="w-8 h-8 text-red-500" data-id="element-188" />
              Para Quién NO Es
            </h3>
            <ul className="space-y-6" data-id="element-189">
              {isNotFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-190">
                  <div className="w-2 h-2 rounded-full bg-red-500 mt-2.5 shrink-0" data-id="element-191" />
                  <p className="text-lg text-gray-300" data-id="element-192">{text}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}